import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import ShowComponent from "../hocs/ShowComponent";

@ShowComponent
class OverviewComparisonTextComponent extends React.Component {
  render() {
    const { mortgage, houseValue, nhg } = this.props;
    const withNhg = nhg ? 'met' : 'zonder';

    return (
      <div className="overview-container--overview-interest-payment-comparison no-mobile">
        <h2>Uw voordeel</h2>
        <p>Op basis van een woningwaarde van €&nbsp;{numeral(houseValue).format('0,00.')}&nbsp;
        en een hypotheek van €&nbsp;{numeral(mortgage).format('0,00.')} {withNhg} NHG,
          20 jaar (240&nbsp;maanden) rentevast, 30&nbsp;jaar (360&nbsp;maanden) looptijd</p>
      </div>
    );
  }
}

OverviewComparisonTextComponent.protoTypes = {
  nhg: PropTypes.bool,
  mortgage: PropTypes.number,
  houseValue: PropTypes.number,
};

OverviewComparisonTextComponent.defaultProps = {
  nhg: false,
  mortgage: 0,
  houseValue: 0,
};

export default OverviewComparisonTextComponent;
